// myProductUtil.js

// 定义一个Map来存储所有的翻译数据

// Something wrong, please refresh the window.
// Import by URL
// Price Range
// Under
const translations = new Map([
    ["en", {
        "product search": "Product Search",
        "ship to": "Ship to",
        "sort": "Sort",
        "default": "Default",
        "price: low to high": "Price: Low to High",
        "price: high to low": "Price: High to Low",
        "sales: high to low": "Sales: High to Low",
        "price": "Price",
        "sales": "Sales",
        "all categories": "All Categories",
        "cellphones & telecommunications": "Cellphones & Telecommunications",
        "cellphones": "Cellphones",
        "phone holders & stands": "Phone Holders & Stands",
        "consumer electronics": "Consumer Electronics",
        "earphones & headphones": "Earphones & Headphones",
        "security & protection": "Security & Protection",
        "tools": "Tools",
        "computer & office": "Computer & Office",
        "electronic components & supplies": "Electronic Components & Supplies",
        "automobiles & motorcycles": "Automobiles & Motorcycles",
        "home improvement": "Home Improvement",
        "home & garden": "Home & Garden",
        "sports & entertainment": "Sports & Entertainment",
        "lights & lighting": "Lights & Lighting",
        "toys & hobbies": "Toys & Hobbies",
        "beauty & health": "Beauty & Health",
        "education & office supplies": "Education & Office Supplies",
        "jewelry & accessories": "Jewelry & Accessories",
        "home appliances": "Home Appliances",
        "luggage & bags": "Luggage & Bags",
        "mother & kids": "Mother & Kids",
        "product category": "Product Category",
        "price range": "Price Range",
        "min": "Min",
        "max": "Max",
        "clear": "clear",
        "sold": "sold",
        "sale": "Sale",
        "add to my products": "Add to My Products",
        "added to my products": "Added to My Products",
        "don’t you see the product you are looking for?": "Don’t you see the product you are looking for?",
        "the product is added to my products tab.": "The product is added to My Products tab.",
        "ship to country is updated": "Ship to country is updated",
        "failed to update ship-to country": "Failed to update ship-to country",
        "currency is updated": "Currency is updated",
        "failed to update currency": "Failed to update currency",
        "install cartifind importer for best experience": "Install Cartifind Importer For Best Experience",
        "congratulations, you are on your way to": "Congratulations, you are on your way to",
        "install cartifind importer": "INSTALL CARTIFIND IMPORTER",
        "continue without it": "CONTINUE WITHOUT IT",
        "currency": "Currency",
        "import by url": "Import by URL",
        "something wrong, please refresh the window.": "Something wrong, please refresh the window.",
        "under": "Under",
        "under price": "Under ${price}",
        "over": "Over",
        "search": "Search",
        "you don't have a valid cartifind plan.": "You don't have a valid Cartifind plan.",
        "you've reached your daily product import limit.": "You've reached your daily product import limit.",
        "you've reached your chatgpt daily usage limit.": "You've reached your AI daily usage limit.",
        "you've reached your ai daily usage limit.": "You've reached your AI daily usage limit.",
        "view details": "View Details",
        "the product is adding to my products tab.": "The product is adding to My Products tab.",
        "view": "View",
        // 英语
    }],
    ["zh", {
        "product search": "产品搜索",
        "ship to": "发货至",
        "sort": "排序",
        "default": "默认",
        "price: low to high": "价格：从低到高",
        "price: high to low": "价格：从高到低",
        "sales: high to low": "销量：从高到低",
        "price": "价格",
        "sales": "销量",
        "all categories": "所有类别",
        "cellphones & telecommunications": "手机和电信",
        "cellphones": "手机",
        "phone holders & stands": "手机支架和支撑",
        "consumer electronics": "消费电子",
        "earphones & headphones": "耳机和耳机",
        "security & protection": "安全与保护",
        "tools": "工具",
        "computer & office": "计算机与办公",
        "electronic components & supplies": "电子元件与供应",
        "automobiles & motorcycles": "汽车与摩托车",
        "home improvement": "家居改善",
        "home & garden": "家居与花园",
        "sports & entertainment": "体育与娱乐",
        "lights & lighting": "灯光与照明",
        "toys & hobbies": "玩具与爱好",
        "beauty & health": "美容与健康",
        "education & office supplies": "教育与办公用品",
        "jewelry & accessories": "珠宝与配件",
        "home appliances": "家电",
        "luggage & bags": "行李与包包",
        "mother & kids": "母婴",
        "product category": "产品类别",
        "price range": "价格范围",
        "min": "最小",
        "max": "最大",
        "clear": "清除",
        "sold": "已售",
        "sale": "特价",
        "add to my products": "添加到我的产品",
        "added to my products": "已添加到我的产品",
        "don’t you see the product you are looking for?": "没有找到您要找的商品？",
        "the product is added to my products tab.": "该产品已添加到我的产品标签。",
        "ship to country is updated": "发货国家已更新",
        "ship to country fail to update": "发货国家更新失败",
        "currency is updated": "币种已更新",
        "currency fail to update": "币种更新失败",
        "install cartifind importer for best experience": "安装Cartifind导入工具以获得最佳体验",
        "congratulations, you are on your way to": "恭喜，您正在迈向",
        "install cartifind importer": "安装Cartifind导入工具",
        "continue without it": "继续使用但不安装",
        "currency": "货币",
        "import by url": "通过 URL 导入",
        "something wrong, please refresh the window.": "出现问题，请刷新窗口。",
        "under": "低于",
        "under price": "低于 ${price}",
        "over": "高于",
        "search": "搜索",
        "you don't have a valid cartifind plan.": "你没有有效的Cartifind计划。",
        "you've reached your daily product import limit.": "你已达到每日产品导入上限。",
        "you've reached your chatgpt daily usage limit.": "你已达到AI每日使用上限。",
        "you've reached your ai daily usage limit.": "你已达到AI每日使用上限。",
        "view details": "查看详情",
        "the product is adding to my products tab.": "产品正在添加到我的产品标签。",
        "view": "查看",
        // 汉语
    }],
    ["ar", {
        "product search": "بحث المنتج",
        "ship to": "الشحن إلى",
        "sort": "ترتيب",
        "default": "افتراضي",
        "price: low to high": "السعر: من الأقل إلى الأعلى",
        "price: high to low": "السعر: من الأعلى إلى الأدنى",
        "sales: high to low": "المبيعات: من الأعلى إلى الأدنى",
        "price": "السعر",
        "sales": "المبيعات",
        "all categories": "جميع الفئات",
        "cellphones & telecommunications": "الهواتف والاتصالات",
        "cellphones": "الهواتف",
        "phone holders & stands": "حاملات الهواتف والأرجل",
        "consumer electronics": "الإلكترونيات الاستهلاكية",
        "earphones & headphones": "السماعات وسماعات الرأس",
        "security & protection": "الأمن والحماية",
        "tools": "الأدوات",
        "computer & office": "الكمبيوتر والمكتب",
        "electronic components & supplies": "المكونات الإلكترونية والإمدادات",
        "automobiles & motorcycles": "السيارات والدراجات النارية",
        "home improvement": "تحسين المنزل",
        "home & garden": "المنزل والحديقة",
        "sports & entertainment": "الرياضة والترفيه",
        "lights & lighting": "الإضاءة والإضاءة",
        "toys & hobbies": "الألعاب والهوايات",
        "beauty & health": "الجمال والصحة",
        "education & office supplies": "الإمدادات التعليمية والمكتبية",
        "jewelry & accessories": "المجوهرات والإكسسوارات",
        "home appliances": "الأجهزة المنزلية",
        "luggage & bags": "الحقائب والأمتعة",
        "mother & kids": "الأم والأطفال",
        "product category": "فئة المنتج",
        "price range": "نطاق السعر",
        "min": "أدنى",
        "max": "أقصى",
        "clear": "مسح",
        "sold": "تم البيع",
        "sale": "البيع",
        "add to my products": "أضف إلى منتجاتي",
        "added to my products": "تمت إضافته إلى منتجاتي",
        "don’t you see the product you are looking for?": "هل لا تجد المنتج الذي تبحث عنه؟",
        "the product is added to my products tab.": "تمت إضافة المنتج إلى علامة التبويب منتجاتي.",
        "ship to country is updated": "تم تحديث بلد الشحن",
        "ship to country fail to update": "فشل في تحديث بلد الشحن",
        "currency is updated": "تم تحديث العملة",
        "currency fail to update": "فشل في تحديث العملة",
        "install cartifind importer for best experience": "قم بتثبيت مستورد Cartifind للحصول على أفضل تجربة",
        "congratulations, you are on your way to": "مبروك، أنت في طريقك إلى",
        "install cartifind importer": "تثبيت مستورد Cartifind",
        "continue without it": "استمرار بدون ذلك",
        "currency": "العملة",
        "import by url": "استيراد عن طريق URL",
        "something wrong, please refresh the window.": "هناك خطأ ، يرجى تحديث النافذة.",
        "under": "أقل من",
        "under price": "أقل من${price}",
        "over": "أكثر من",
        "search": "بحث",
        "you don't have a valid cartifind plan.": "ليس لديك خطة صالحة لـ Cartifind.",
        "you've reached your daily product import limit.": "لقد وصلت إلى الحد الأقصى لاستيراد المنتجات اليومية.",
        "you've reached your chatgpt daily usage limit.": "لقد وصلت إلى الحد اليومي لاستخدام الذكاء الاصطناعي.",
        "you've reached your ai daily usage limit.": "لقد وصلت إلى الحد اليومي لاستخدام الذكاء الاصطناعي.",
        "view details": "عرض التفاصيل",
        "the product is adding to my products tab.": "يتم إضافة المنتج إلى علامة التبويب منتجاتي.",
        "view": "عرض",
        // 阿拉伯语
    }],
    ["es", {
        "product search": "Búsqueda de productos",
        "ship to": "Enviar a",
        "sort": "Ordenar",
        "default": "Predeterminado",
        "price: low to high": "Precio: de bajo a alto",
        "price: high to low": "Precio: de alto a bajo",
        "sales: high to low": "Ventas: de alto a bajo",
        "price": "Precio",
        "sales": "Ventas",
        "all categories": "Todas las categorías",
        "cellphones & telecommunications": "Celulares y telecomunicaciones",
        "cellphones": "Celulares",
        "phone holders & stands": "Soportes y bases para teléfonos",
        "consumer electronics": "Electrónica de consumo",
        "earphones & headphones": "Auriculares y audífonos",
        "security & protection": "Seguridad y protección",
        "tools": "Herramientas",
        "computer & office": "Computadoras y oficina",
        "electronic components & supplies": "Componentes electrónicos y suministros",
        "automobiles & motorcycles": "Automóviles y motocicletas",
        "home improvement": "Mejoras del hogar",
        "home & garden": "Hogar y jardín",
        "sports & entertainment": "Deportes y entretenimiento",
        "lights & lighting": "Luces y iluminación",
        "toys & hobbies": "Juguetes y hobbies",
        "beauty & health": "Belleza y salud",
        "education & office supplies": "Material escolar y de oficina",
        "jewelry & accessories": "Joyería y accesorios",
        "home appliances": "Electrodomésticos",
        "luggage & bags": "Equipaje y bolsos",
        "mother & kids": "Madre e hijos",
        "product category": "Categoría del producto",
        "price range": "Rango de precios",
        "min": "Mín",
        "max": "Máx",
        "clear": "Borrar",
        "sold": "Vendido",
        "sale": "Venta",
        "add to my products": "Agregar a mis productos",
        "added to my products": "Agregado a mis productos",
        "don’t you see the product you are looking for?": "¿No ves el producto que buscas?",
        "the product is added to my products tab.": "El producto ha sido agregado a la pestaña de Mis productos.",
        "ship to country is updated": "El país de envío ha sido actualizado",
        "ship to country fail to update": "Fallo al actualizar el país de envío",
        "currency is updated": "La moneda ha sido actualizada",
        "currency fail to update": "Fallo al actualizar la moneda",
        "install cartifind importer for best experience": "Instalar Cartifind Importer para la mejor experiencia",
        "congratulations, you are on your way to": "Felicidades, estás en camino a",
        "install cartifind importer": "INSTALAR CARTIFIND IMPORTER",
        "continue without it": "CONTINUAR SIN ÉL",
        "currency": "Moneda",
        "import by url": "Importar por URL",
        "something wrong, please refresh the window.": "Algo salió mal, por favor actualice la ventana.",
        "under": "Menos de",
        "under price": "Menos de ${price}",
        "over": "Más de",
        "search": "Buscar",
        "you don't have a valid cartifind plan.": "No tienes un plan válido de Cartifind.",
        "you've reached your daily product import limit.": "Has alcanzado tu límite diario de importación de productos.",
        "you've reached your chatgpt daily usage limit.": "Has alcanzado tu límite diario de uso de IA.",
        "you've reached your ai daily usage limit.": "Has alcanzado tu límite diario de uso de IA.",
        "view details": "Ver detalles",
        "the product is adding to my products tab.": "El producto se está añadiendo a la pestaña Mis Productos.",
        "view": "Ver",
        // 西班牙语
    }],
    ["fr", {
        "product search": "Recherche de produits",
        "ship to": "Expédier à",
        "sort": "Trier",
        "default": "Par défaut",
        "price: low to high": "Prix : Du moins cher au plus cher",
        "price: high to low": "Prix : Du plus cher au moins cher",
        "sales: high to low": "Ventes : Du plus élevé au plus bas",
        "price": "Prix",
        "sales": "Ventes",
        "all categories": "Toutes les catégories",
        "cellphones & telecommunications": "Téléphones et télécommunications",
        "cellphones": "Téléphones",
        "phone holders & stands": "Supports et trépieds pour téléphones",
        "consumer electronics": "Électronique grand public",
        "earphones & headphones": "Écouteurs et casques",
        "security & protection": "Sécurité et protection",
        "tools": "Outils",
        "computer & office": "Informatique et bureau",
        "electronic components & supplies": "Composants électroniques et fournitures",
        "automobiles & motorcycles": "Automobiles et motos",
        "home improvement": "Amélioration de l'habitat",
        "home & garden": "Maison et jardin",
        "sports & entertainment": "Sports et loisirs",
        "lights & lighting": "Éclairage et lumières",
        "toys & hobbies": "Jouets et loisirs",
        "beauty & health": "Beauté et santé",
        "education & office supplies": "Fournitures scolaires et de bureau",
        "jewelry & accessories": "Bijoux et accessoires",
        "home appliances": "Électroménagers",
        "luggage & bags": "Bagages et sacs",
        "mother & kids": "Mères et enfants",
        "product category": "Catégorie de produit",
        "price range": "Plage de prix",
        "min": "Min",
        "max": "Max",
        "clear": "Effacer",
        "sold": "Vendu",
        "sale": "Vente",
        "add to my products": "Ajouter à mes produits",
        "added to my products": "Ajouté à mes produits",
        "don’t you see the product you are looking for?": "Vous ne trouvez pas le produit que vous cherchez ?",
        "the product is added to my products tab.": "Le produit a été ajouté à l'onglet Mes produits.",
        "ship to country is updated": "Le pays d'expédition a été mis à jour",
        "ship to country fail to update": "Échec de la mise à jour du pays d'expédition",
        "currency is updated": "La devise a été mise à jour",
        "currency fail to update": "Échec de la mise à jour de la devise",
        "install cartifind importer for best experience": "Installez Cartifind Importer pour une meilleure expérience",
        "congratulations, you are on your way to": "Félicitations, vous êtes en route pour",
        "install cartifind importer": "INSTALLER CARTIFIND IMPORTER",
        "continue without it": "CONTINUER SANS",
        "currency": "Devise",
        "import by url": "Importer par URL",
        "something wrong, please refresh the window.": "Quelque chose ne va pas, veuillez rafraîchir la fenêtre.",
        "under": "Moins de",
        "under price": "Moins de ${price}",
        "over": "Plus de",
        "search": "Rechercher",
        "you don't have a valid cartifind plan.": "Vous n'avez pas de plan Cartifind valide.",
        "you've reached your daily product import limit.": "Vous avez atteint votre limite quotidienne d'importation de produits.",
        "you've reached your chatgpt daily usage limit.": "Vous avez atteint votre limite quotidienne d'utilisation de l'IA.",
        "you've reached your ai daily usage limit.": "Vous avez atteint votre limite quotidienne d'utilisation de l'IA.",
        "view details": "Voir les détails",
        "the product is adding to my products tab.": "Le produit est en cours d'ajout à l'onglet Mes Produits.",
        "view": "Voir",
        // 法语
    }],
    ["it", {
        "product search": "Ricerca prodotto",
        "ship to": "Spedire a",
        "sort": "Ordina",
        "default": "Predefinito",
        "price: low to high": "Prezzo: dal più basso al più alto",
        "price: high to low": "Prezzo: dal più alto al più basso",
        "sales: high to low": "Vendite: dal più alto al più basso",
        "price": "Prezzo",
        "sales": "Vendite",
        "all categories": "Tutte le categorie",
        "cellphones & telecommunications": "Cellulari e telecomunicazioni",
        "cellphones": "Cellulari",
        "phone holders & stands": "Supporti e cavalletti per telefoni",
        "consumer electronics": "Elettronica di consumo",
        "earphones & headphones": "Cuffie e auricolari",
        "security & protection": "Sicurezza e protezione",
        "tools": "Strumenti",
        "computer & office": "Computer e ufficio",
        "electronic components & supplies": "Componenti elettronici e forniture",
        "automobiles & motorcycles": "Automobili e motociclette",
        "home improvement": "Miglioramenti per la casa",
        "home & garden": "Casa e giardino",
        "sports & entertainment": "Sport e intrattenimento",
        "lights & lighting": "Illuminazione e luci",
        "toys & hobbies": "Giochi e hobby",
        "beauty & health": "Bellezza e salute",
        "education & office supplies": "Forniture educative e per ufficio",
        "jewelry & accessories": "Gioielli e accessori",
        "home appliances": "Elettrodomestici",
        "luggage & bags": "Valigie e borse",
        "mother & kids": "Mamma e bambini",
        "product category": "Categoria prodotto",
        "price range": "Fascia di prezzo",
        "min": "Min",
        "max": "Max",
        "clear": "Cancella",
        "sold": "Venduto",
        "sale": "Offerta",
        "add to my products": "Aggiungi ai miei prodotti",
        "added to my products": "Aggiunto ai miei prodotti",
        "don’t you see the product you are looking for?": "Non vedi il prodotto che stai cercando?",
        "the product is added to my products tab.": "Il prodotto è stato aggiunto alla mia tabella Prodotti.",
        "ship to country is updated": "Il paese di spedizione è stato aggiornato",
        "ship to country fail to update": "Aggiornamento del paese di spedizione fallito",
        "currency is updated": "La valuta è stata aggiornata",
        "currency fail to update": "Aggiornamento della valuta fallito",
        "install cartifind importer for best experience": "Installa Cartifind Importer per una migliore esperienza",
        "congratulations, you are on your way to": "Congratulazioni, sei sulla strada per",
        "install cartifind importer": "INSTALLA CARTIFIND IMPORTER",
        "continue without it": "CONTINUA SENZA",
        "currency": "Valuta",
        "import by url": "Importa tramite URL",
        "something wrong, please refresh the window.": "Qualcosa non va, per favore aggiorna la finestra.",
        "under": "Meno di",
        "under price": "Meno di ${price}",
        "over": "Più di",
        "search": "Cerca",
        "you don't have a valid cartifind plan.": "Non hai un piano Cartifind valido.",
        "you've reached your daily product import limit.": "Hai raggiunto il limite giornaliero di importazione dei prodotti.",
        "you've reached your chatgpt daily usage limit.": "Hai raggiunto il limite giornaliero di utilizzo dell'AI.",
        "you've reached your ai daily usage limit.": "Hai raggiunto il limite giornaliero di utilizzo dell'AI.",
        "view details": "Visualizza dettagli",
        "the product is adding to my products tab.": "Il prodotto viene aggiunto alla scheda I miei prodotti.",
        "view": "Visualizza"
        // 意大利语
    }],
    ["de", {
        "product search": "Produktsuche",
        "ship to": "Versenden an",
        "sort": "Sortieren",
        "default": "Standard",
        "price: low to high": "Preis: Niedrig bis Hoch",
        "price: high to low": "Preis: Hoch bis Niedrig",
        "sales: high to low": "Verkäufe: Hoch bis Niedrig",
        "price": "Preis",
        "sales": "Verkäufe",
        "all categories": "Alle Kategorien",
        "cellphones & telecommunications": "Handys und Telekommunikation",
        "cellphones": "Handys",
        "phone holders & stands": "Handyhalter und Ständer",
        "consumer electronics": "Verbraucherelektronik",
        "earphones & headphones": "Kopfhörer und Ohrhörer",
        "security & protection": "Sicherheit und Schutz",
        "tools": "Werkzeuge",
        "computer & office": "Computer und Büro",
        "electronic components & supplies": "Elektronische Komponenten und Lieferungen",
        "automobiles & motorcycles": "Autos und Motorräder",
        "home improvement": "Heimwerkerbedarf",
        "home & garden": "Haus und Garten",
        "sports & entertainment": "Sport und Unterhaltung",
        "lights & lighting": "Beleuchtung und Lichter",
        "toys & hobbies": "Spielzeug und Hobbys",
        "beauty & health": "Schönheit und Gesundheit",
        "education & office supplies": "Bildung und Bürobedarf",
        "jewelry & accessories": "Schmuck und Accessoires",
        "home appliances": "Haushaltsgeräte",
        "luggage & bags": "Gepäck und Taschen",
        "mother & kids": "Mutter und Kinder",
        "product category": "Produktkategorie",
        "price range": "Preisspanne",
        "min": "Min",
        "max": "Max",
        "clear": "Löschen",
        "sold": "Verkauft",
        "sale": "Verkauf",
        "add to my products": "Zu meinen Produkten hinzufügen",
        "added to my products": "Zu meinen Produkten hinzugefügt",
        "don’t you see the product you are looking for?": "Sehen Sie das Produkt, das Sie suchen, nicht?",
        "the product is added to my products tab.": "Das Produkt wurde zu meinen Produkten hinzugefügt.",
        "ship to country is updated": "Das Versandland wurde aktualisiert",
        "ship to country fail to update": "Fehler beim Aktualisieren des Versandlandes",
        "currency is updated": "Währung wurde aktualisiert",
        "currency fail to update": "Fehler bei der Aktualisierung der Währung",
        "install cartifind importer for best experience": "Installieren Sie den Cartifind Importer für die beste Erfahrung",
        "congratulations, you are on your way to": "Herzlichen Glückwunsch, Sie sind auf dem Weg zu",
        "install cartifind importer": "INSTALLIEREN SIE DEN CARTIFIND IMPORTER",
        "continue without it": "OHNE FORTSETZEN",
        "currency": "Währung",
        "import by url": "Per URL importieren",
        "something wrong, please refresh the window.": "Etwas ist schief gelaufen, bitte aktualisieren Sie das Fenster.",
        "under": "Unter",
        "under price": "Unter ${price}",
        "over": "Über",
        "search": "Suche",
        "you don't have a valid cartifind plan.": "Sie haben keinen gültigen Cartifind-Plan.",
        "you've reached your daily product import limit.": "Sie haben Ihr tägliches Produktimportlimit erreicht.",
        "you've reached your chatgpt daily usage limit.": "Sie haben Ihr tägliches AI-Nutzungslimit erreicht.",
        "you've reached your ai daily usage limit.": "Sie haben Ihr tägliches AI-Nutzungslimit erreicht.",
        "view details": "Details anzeigen",
        "the product is adding to my products tab.": "Das Produkt wird zum Tab Meine Produkte hinzugefügt.",
        "view": "Ansehen",
        // 德语
    }]
]);

// 获取当前语言，默认为英语
const getCurrentLanguage = () => {
    const language = localStorage.getItem('language'); // 从localStorage获取语言
    return language ? language : 'en'; // 默认返回英语
};

// i18函数根据当前语言返回翻译的内容
export const i18 = (key, values = {}) => {
    const LowerCaseKey = key?.toLowerCase();
    const currentLanguage = getCurrentLanguage(); // 获取当前语言
    const languageTranslations = translations.get(currentLanguage); // 获取当前语言的翻译数据

    let translation = languageTranslations && languageTranslations[LowerCaseKey] ? languageTranslations[LowerCaseKey] : key; // 获取翻译，如果没有找到，则返回原始key

    // 动态替换占位符
    for (const placeholder in values) {
        const regex = new RegExp(`\\$\\{${placeholder}\\}`, 'g'); // 创建匹配占位符的正则表达式
        translation = translation.replace(regex, values[placeholder]); // 替换占位符
    }

    return translation; // 返回最终的翻译字符串
};

